import { useEffect, useState } from "react";
import { NumberObj } from "../types/NumberObj";
import { v4 as uuid } from 'uuid';

export const useInspectionHooks = () => {
    const [ numbers, setNumbers ] = useState<NumberObj[]>([]);
    const [ checked, setChecked ] = useState(false);
    const [ count, setCount ] = useState(0);

    useEffect (() => {
        if (checked) {
            setChecked(!checked);
        } else {
            let doubleCheck: string[] = [];
            let deepCopy = numbers.map((number) => ({ ...number }));

            deepCopy.map((number) => {
                if(doubleCheck.includes(number.num) || number.num === ''){
                    number.deleteFlg = true;
                } else {
                    number.deleteFlg = false;
                    doubleCheck.push(number.num);
                }
            });
            setCount(doubleCheck.length);
            setNumbers(deepCopy);
            setChecked(!checked);
        }
    }, [numbers])

    const addNumber = (firstValue: string) => {
        const newNumber: NumberObj = {
            id: uuid(),
            num: firstValue,
            num_ai: firstValue,
            deleteFlg: false
        };

        setNumbers([...numbers, newNumber]);
    };

    const handleEdit = (id: string, inputValue: string) => {
        const deepCopy = numbers.map((number) => ({ ...number }));

        let isDuplicated = false

        numbers.map(number => {
            if (number.num == inputValue){
                isDuplicated = true;
            }
        });

        const newNumbers = deepCopy.map((number) => {
            if (number.id === id) {
            number.num = inputValue;
            number.deleteFlg = isDuplicated;
            if(inputValue === ""){
                number.deleteFlg = true;
            }
            }
            return number;
        });

        setNumbers(newNumbers);
    };

    const handleDelete = (id: string) => {
        const newNumbers = numbers.filter((number) => number.id !== id);
        setNumbers(newNumbers);
    };

    return { numbers, setNumbers, count, handleEdit, addNumber, handleDelete };
};